const ScrollToTop = () => {
	// window.scrollTo(0, 0);
	window.scroll({ top: 0, left: 0, behavior: 'smooth' });
};

export default ScrollToTop;
